export const Marquee = () => (
  <div
    className="relative py-10 md:py-14 overflow-hidden border-y border-[#171717]/8"
    aria-hidden="true"
    data-testid="editorial-marquee"
  >
    <div className="flex whitespace-nowrap marquee-track">
      {[0, 1].map((i) => (
        <span
          key={i}
          className="font-heading text-4xl md:text-6xl lg:text-7xl uppercase tracking-tight text-[#171717]/[0.08] font-medium px-6"
        >
          Track. Understand. Adjust. Repeat. — The Habit Loop.&nbsp;
        </span>
      ))}
    </div>
  </div>
);
